import { User } from "../../classes";
import router from '../../router'
// import { clearCookie } from '@arv-bedrock/auth-sso'
import vuetify from "../../plugins/vuetify";
const UserModule = {
  namespaced: true,
  state: () => ({
    isLoggedIn: false,
    sessionToken: "",
    userInfo: null,
    isBedrockAuth: false,
  }),
  actions: {
    login: async ({ commit, dispatch }, payload) => {
      try {
        const data = await User.logIn({
          username: payload.username,
          password: payload.password
        });
        localStorage.setItem("sessionToken", data.sessionToken);
        if(data && payload.locale){
         await dispatch("updateUser", {
            locale: payload.locale,
            ignoreGetUserInfo: true,
          })
        }
        return data;
      } catch (err) {
        throw err;
      }
    },
    signup: async ({ commit, dispatch }, payload) => {
      try {
        const data = await User.signUp(payload);
        localStorage.setItem("sessionToken", data.sessionToken);
        dispatch("getUserInfo");
        return data;
      } catch (err) {
        throw err;
      }
    },
    changeUserPassword: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await User.changeUserPassword(payload);
        commit("resetSessionToken", { isLoggedIn: false });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateUser: async ({ commit, dispatch }, payload) => {
      try {
        const data = await User.updateUser(payload);
        if(!payload.ignoreGetUserInfo){
          dispatch("getUserInfo");
        }
        return data;
      } catch (err) {
        throw err;
      }
    },
    logout: async ({ state, commit, dispatch }, payload) => {
      try {
        const data = await User.logOut();
        commit("resetSessionToken", { isLoggedIn: false });
        commit("resetUserInfo")
        if (state.isBedrockAuth) {
          // try {
          //   clearCookie()
          // } catch (error) {
          //   console.log(error)
          // }
        }
        return data;
      } catch (err) {
        throw err;
      }
    },
    getUserInfo: async ({ state, commit, dispatch }, payload) => {
      try {
        let userBecome
        if (!state.userInfo) {
          if (localStorage.getItem("sessionToken"))
            userBecome = await dispatch("become")
        }
        const data = await User.getUserInfo();
        commit("setUserInfo", { user: data });
        commit("admin/setSessionAdmins", data.admins, { root: true });
        commit("employee/setSessionEmployees", data.employees, { root: true });
        if (router && router.currentRoute && router.currentRoute.params && router.currentRoute.params.projectId) {
          let currentProject = data.projects.find(pj => pj.objectId == router.currentRoute.params.projectId)
          if (currentProject && currentProject.isPackageExpired) {
            await router.push('/')
          }
        }
        if (data?.user?.authProvider == 'Bedrock') {
          if (vuetify?.preset?.theme?.themes?.light?.primary)
            vuetify.preset.theme.themes.light.primary = vuetify.preset.theme.themes.light.bedrock
          if (vuetify?.framework?.theme?.themes?.light?.primary)
            vuetify.framework.theme.themes.light.primary = vuetify.framework.theme.themes.light.bedrock
          if (vuetify?.userPreset?.theme?.themes?.light?.primary)
            vuetify.userPreset.theme.themes.light.primary = vuetify.userPreset.theme.themes.light.bedrock

          if (vuetify?.preset?.theme?.themes?.light?.footer)
            vuetify.preset.theme.themes.light.footer = vuetify.preset.theme.themes.light.bedrock
          if (vuetify?.framework?.theme?.themes?.light?.footer)
            vuetify.framework.theme.themes.light.footer = vuetify.framework.theme.themes.light.bedrock
          if (vuetify?.userPreset?.theme?.themes?.light?.footer)
            vuetify.userPreset.theme.themes.light.footer = vuetify.userPreset.theme.themes.light.bedrock

        } else {
          if (vuetify?.preset?.theme?.themes?.light?.primary)
            vuetify.preset.theme.themes.light.primary = vuetify.preset.theme.themes.dark.primary
          if (vuetify?.framework?.theme?.themes?.light?.primary)
            vuetify.framework.theme.themes.light.primary = vuetify.framework.theme.themes.dark.primary
          if (vuetify?.userPreset?.theme?.themes?.light?.primary)
            vuetify.userPreset.theme.themes.light.primary = vuetify.userPreset.theme.themes.dark.primary

          if (vuetify?.preset?.theme?.themes?.light?.footer)
            vuetify.preset.theme.themes.light.footer = vuetify.preset.theme.themes.dark.footer
          if (vuetify?.framework?.theme?.themes?.light?.footer)
            vuetify.framework.theme.themes.light.footer = vuetify.framework.theme.themes.dark.footer
          if (vuetify?.userPreset?.theme?.themes?.light?.footer)
            vuetify.userPreset.theme.themes.light.footer = vuetify.userPreset.theme.themes.dark.footer
        }
        return data;
      } catch (err) {
        throw err;
      }
    },
    loginSSO: async ({ commit, dispatch }, payload) => {
      try {
        const data = await User.loginSSO({
          profile: payload.profile,
          providerName: payload.providerName
        });
        localStorage.setItem("sessionToken", data.sessionToken);
        dispatch("getUserInfo");
        return data;
      } catch (err) {
        throw err;
      }
    },
    become: async () => {
      let userBecome
      try {
        userBecome = await User.become()
      } catch (error) {
        userBecome = null
      }
      return userBecome;
    },
  },
  getters: {
    getFullName: state =>
      `${state.userInfo?.user?.firstName} ${state.userInfo?.user?.lastName}`,
    getProjectMarket: state => state.userInfo?.admins,
    countProject: state => state.userInfo?.admins?.length,
    getUser: state => state.userInfo?.user,
    getUserInfo: state => state.userInfo,
    getMarketIds: state => {
      const newFinalArr = []
      state.userInfo?.admins?.forEach(i => i?.project.markets?.forEach(r => { newFinalArr.push(r.objectId) }))
      return newFinalArr
    },
    getProjectMarketIds: state => {
      const newArr = state.userInfo?.admins?.map(i => ({ projectId: i.project.objectId, markets: i?.project.markets?.map(r => r.objectId) }))
      return newArr
    },
    getByProjectId: (state) => (id) => {
      const projects = state.userInfo.projects
      return projects && projects.length ? projects.find(pj => pj.objectId === id) : null
    },
    getApproveWaitingStatus: (state) => (id) => {
      let status = 0
      let admin = state.userInfo.admins.find(a => a.market && a.market.objectId == id)
      let employee = state.userInfo.employees.find(a => a.market && a.market.objectId == id)
      if (employee) {
        status = employee.countApproveTask
      }
      if (admin) {
        status = admin.countApproveTask
      }
      return status
    },
    isAuthBedrock: (state) => state.userInfo?.user?.authProvider == 'Bedrock' ? true : false,
    isBedrockAuth: (state) => state.isBedrockAuth,
  },
  mutations: {
    setSessionToken: (state, payload) => {
      state.sessionToken = payload.sessionToken;
    },
    resetSessionToken: (state, payload) => {
      state.sessionToken = "";
      state.isLoggedIn = payload.isLoggedIn;
      localStorage.removeItem("sessionToken");
    },
    setUserInfo: (state, payload) => {
      state.userInfo = payload.user;
    },
    resetUserInfo: (state, payload) => {
      state.userInfo = null;

      if (vuetify?.preset?.theme?.themes?.light?.primary)
        vuetify.preset.theme.themes.light.primary = vuetify.preset.theme.themes.dark.primary
      if (vuetify?.framework?.theme?.themes?.light?.primary)
        vuetify.framework.theme.themes.light.primary = vuetify.framework.theme.themes.dark.primary
      if (vuetify?.userPreset?.theme?.themes?.light?.primary)
        vuetify.userPreset.theme.themes.light.primary = vuetify.userPreset.theme.themes.dark.primary

      if (vuetify?.preset?.theme?.themes?.light?.footer)
        vuetify.preset.theme.themes.light.footer = vuetify.preset.theme.themes.dark.footer
      if (vuetify?.framework?.theme?.themes?.light?.footer)
        vuetify.framework.theme.themes.light.footer = vuetify.framework.theme.themes.dark.footer
      if (vuetify?.userPreset?.theme?.themes?.light?.footer)
        vuetify.userPreset.theme.themes.light.footer = vuetify.userPreset.theme.themes.dark.footer
    },
    setBedrockAuth: (state, isBedrockAuth) => {
      state.isBedrockAuth = isBedrockAuth;
    },
  }
};
export default UserModule;
